module.exports = __webpack_public_path__ + "static/media/invoiceIcon.05b57a05.svg";